import React, { lazy } from 'react';
const LearnToDriveWithUs = () => {
  return <section className="py-12 bg-white" data-id="element-213">
      <div className="container mx-auto px-4" data-id="element-214">
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-8" data-id="element-215">
          Learn To Drive With Us
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-216">
          <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-217">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/7mwVa6bd4whWYLDnonxPhc/learner_driver.png" alt="Automatic Driving Lessons Northampton" className="w-full h-48 object-cover" loading="lazy" data-id="element-218" />
            <div className="p-4" data-id="element-219">
              <p className="text-gray-700" data-id="element-220">
                Modern automatic vehicles with dual controls and L plates for
                learner safety
              </p>
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-221">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6C9xyeasQSxYB3YLkQ23gw/Trsuted_driver.png" alt="Driving Instructor Northampton" className="w-full h-48 object-cover" loading="lazy" data-id="element-222" />
            <div className="p-4" data-id="element-223">
              <p className="text-gray-700" data-id="element-224">
                Professional instruction in a comfortable, relaxed learning
                environment
              </p>
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-225">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/wUvF8AjcNPDv3veNxhm1d5/instructor.png" alt="10-hour driving lessons Northampton" className="w-full h-48 object-cover" loading="lazy" data-id="element-226" />
            <div className="p-4" data-id="element-227">
              <p className="text-gray-700" data-id="element-228">
                Build confidence with each lesson as you progress toward test
                readiness
              </p>
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-229">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3xhxZjwjUY4ZL4apAphEPi/patient_instructor.png" alt="DVSA Test Booking Northampton" className="w-full h-48 object-cover" loading="lazy" data-id="element-230" />
            <div className="p-4" data-id="element-231">
              <p className="text-gray-700" data-id="element-232">
                Expert guidance from patient instructors who understand your
                learning needs
              </p>
            </div>
          </div>
        </div>
        <div className="text-center mt-8" data-id="element-233">
          <a href="https://www.totaldrive.app/a/enquiry_form.php?17584722727972" target="_blank" rel="noopener noreferrer" className="bg-burgundy-600 hover:bg-burgundy-700 text-white px-6 py-3 rounded-md font-medium inline-block transition-colors" aria-label="Book your driving lessons in Northampton today" data-id="element-234">
            Book Now
          </a>
        </div>
      </div>
    </section>;
};
export default LearnToDriveWithUs;